import React, { FunctionComponent } from 'react'
import store from './redux/store'
import Root from './components/root'
import './i18n/i18n'
import './global-styles/index.css'
import { ReduxStateDebuggerProvider } from './components/dev-tools'

const DCC: FunctionComponent = () => (
  <>
    <Root store={store} />
    <ReduxStateDebuggerProvider />
  </>
)

export default DCC
